export default {
  images: {
    banner: {
      card: '',
      card_sm: '',
      hero: '',
      hero_sm: '',
      original: '',
      pod: '',
      tiny: '',
    }
  },
  title: '',
  id: null,
  stats: {
    read_by_number: 0
  },
  tags: ''
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/article.js